<template>
  <div class="about">
    <h1 class="login-title">注册</h1>
    <div class="login-form">
      <div class="login-form-item login-form-item-input">
        <div class="icon">
          <img src="../assets/mobile-phone.svg" >
        </div>

        <input type="number" class="input" placeholder="输入手机号" v-model="phone">
      </div>
      <div class="login-form-item login-form-item-input"  >
        <div class="icon">
          <img src="../assets/password.svg">
        </div>
        <input type="text" class="input"  v-model="phone_code" placeholder="输入验证码">
        <div class="getverifycode" :class="{disable:time!==0}" @click="getverifycode()">
          <span v-if="time===0">获取验证码</span>
          <span v-else>{{time}}S后重新发送</span>
        </div>
      </div>






      <div class="login-form-item" style="margin-bottom: 0">
        <div class="btn login-btn" @click="register()">注册</div>
      </div>
      <div class="bottom-nav">
        <div class="link" @click="tologin()">登陆</div>

      </div>


    </div>
  </div>
</template>
<style scoped>
  .bottom-nav{ padding: 60px 0; display: flex; justify-content: center; align-items: center; font-size: 14px; color: #6a6a6a; line-height: 30px;}
  .bottom-nav .line{ background-color:#6a6a6a; width: 1px; height: 14px; margin: 0 25px}
</style>
<style >
  input{ background-color: #fff}
  header{ display: flex; justify-content: space-between; align-items: center; height: 50px; font-size: 16px; color: #222222;text-align: center;
    padding-left: 15px; padding-right: 15px;
  }
  .back img{ height: 18px; display: block}


  .header-start,.header-end{ display: flex;align-items: center; width: 80px;}
  .header-end{ justify-content: flex-end}
  .login-logo{ display: block; margin:50px auto; height: 100px}

  .login-form{ padding: 0 20px}
  .login-form-item{ height: 42px; margin-bottom: 30px}
  .login-form-item-input{ border:1px solid #cccccc;border:0.5px solid #cccccc; border-radius: 21px; padding: 0 5px;
    display: flex; justify-content: space-between; align-items: center; position: relative}
  .icon{ display: flex; width: 32px;justify-content: center}
  .icon img{ height: 22px; display: block}
  .input{ display: flex; flex: 1;}
  .getverifycode{ text-wrap: none; position: absolute; right: 0; top:-0.5px; height: 42px;border-radius: 21px; background-color: #ea1f23; color: #fff;
    padding: 0 10px; display: flex; justify-content: center; align-items: center}
  .getverifycode.disable{ background-color: #dcdee0}

  .login-btn{border-radius: 21px; background-color: #ea1f23; color: #fff;height: 42px;
    display: flex; justify-content: center; align-items: center;}

  .xieyi{font-size: 12px;color: #8e8e8e; line-height: 42px }
  .xieyi span{color: #ea1f23}

  .login-form .login-form-item:last-child{ margin-bottom: 0}

  .bottom-nav{ padding: 60px 0; display: flex; justify-content: center; align-items: center; font-size: 14px; color: #6a6a6a; line-height: 30px;}
  .bottom-nav .line{ background-color:#6a6a6a; width: 1px; height: 14px; margin: 0 25px}
  .input{ background-color: transparent}
  .login-title{ text-align: center; margin: 20px 0}
  .login-download-link{ text-align: center;margin-top: 30px; display: block; font-size: 14px}

</style>
<script>
  // @ is an alias to /src
  import { Toast } from 'vant';
  import Request from "../utils/request";
  export default {
    name: 'Login',
    data(){
      return {
        time: 0,
        timer: false,
        pwd: '',
        phone: '',
        phone_code: '',
        //验证码

        lock:false,
        login_way:1
      }
    },
    created() {
      document.title = "登录";
      if(this.$store.state.logined ){
        this.$router.push({name:"Home"})
      }
    },
    methods:{
      tologin(){
        this.$router.push({name:"web_login"})
      },

      register() {
        // this.$store.commit("setLogin",true)
        // this.$router.push({name:"Home"})
        var _this = this;
        if(this.lock){
          return
        }
        this.lock = true;
        if (!this.phone) {
          Toast("请输入手机号码");
          this.lock = false;
          return;
        }
        if (!this.phone_code) {
          this.lock = false;
          Toast("请输入验证码");
          return;
        }

        var postData = {
          phone: this.phone,
          phone_code: this.phone_code
        };



        Request.h5_register(postData,  (res, err)=>{
          console.log(JSON.stringify(res))
          _this.lock = false;
          if (err) {
            Toast("请求失败");
          } else if (res && res.code === 200 && res.data) {
            Toast(res.message);
            localStorage.setItem("webUserData",JSON.stringify(res.data));

            try {
              let d = localStorage.getItem("lastpage");
              if(d){
                let junpdata = JSON.parse(d);
                switch (junpdata.page) {
                  case "NewsContent":
                    //this.$router.push({ path: 'newsContent', query: { id: junpdata.id}})
                    this.$router.push({ name: 'NewsContent', params: { id: junpdata.id } })
                    break
                }

              }


            }catch (e) {
              console.log(e)
              Toast("跳转失败");
            }



          } else if (res && res.message) {
            Toast(res.message);
          } else {
            Toast("请求失败");
          }
        });
      },
      getverifycode() {
        if (!this.phone) {
          Toast("请输入手机号码");
          return;
        }

        if (this.time === 0) {
          var _this = this;


          Request.getWebLoginSms({phone:this.phone,sms_sign:"H5_Register"}, function (res, err) {
            console.log(JSON.stringify(res))
            if (err) {
              Toast("请求失败");
            } else if (res && res.code == 200) {
              Toast(res.message);
              _this.time = 60;
              _this.timer = setInterval(function () {
                _this.time = _this.time - 1;

                if (_this.time <= 0) {
                  _this.time = 0;
                  clearInterval(_this.timer);
                }
              }, 1000);
            }else if(res && res.message){
              Toast(res.message);
            }else{
              Toast("请求失败");
            }
          });

        }
      }
    }
  }
</script>
